import { gql } from "@apollo/client";

export const CREATE_PLATFORM_EVENT_CONTENT = gql`
  mutation createPlatformEventContent(
    $eventId: String!
    $name: String!
    $clusterId: String
    $notifClusterId: String
    $notifSubClusterId: String
    $contentPageSlug: String
    $contentPageType: String
    $body: String
    $imageURL: String
    $linkURL: String
    $keywords: [String!]
    $links: [ContentLinkInput!]
    $images: [String!]
    $subContentType: String!
    $selectedVenue: String
    $isCartAvailable: Boolean
    $isScheduleAvailable: Boolean
    $isPricingAvailable: Boolean
    $isConstraintAvailable: Boolean
    $isVenueChecked: Boolean
    $startDate: DateTime
    $endDate: DateTime
    $pricingType: PricingContentType
    $pricingMaster: CreatePricingInput
    $pricingEmployee: [CreatePricingEmployeeInput!]
    $userNotificationList: [String!]
    $sizeFilterGender: String
    $sizeFilterProductCategory: String
    $sizeFilterCategory: String
    $sizeFilterFeature: String
    $sizeFilterClothingSize: String
    $sizeFilterShoeSize: String
    $sizeFilterStockQuantity: String
    $sizeFilterColour: String
    $isRatingCriteriaChecked: Boolean
    $selectedCriteria: JSON
    $notificationSubClusterIds: [String!]
    $ratingClusterIds: [String!]
    $ratingCriteriaByCluster: JSON
  ) {
    createPlatformEventContent(
      data: {
        eventId: $eventId
        name: $name
        clusterId: $clusterId
        notifClusterId: $notifClusterId
        notifSubClusterId: $notifSubClusterId
        contentPageSlug: $contentPageSlug
        contentPageType: $contentPageType
        body: $body
        imageURL: $imageURL
        linkURL: $linkURL
        keywords: $keywords
        links: $links
        images: $images
        subContentType: $subContentType
        isCartAvailable: $isCartAvailable
        isScheduleAvailable: $isScheduleAvailable
        isPricingAvailable: $isPricingAvailable
        isConstraintAvailable: $isConstraintAvailable
        isVenueChecked: $isVenueChecked
        selectedVenue: $selectedVenue
        startDate: $startDate
        endDate: $endDate
        pricingType: $pricingType
        pricingMaster: $pricingMaster
        pricingEmployee: $pricingEmployee
        userNotificationList: $userNotificationList
        sizeFilterGender: $sizeFilterGender
        sizeFilterProductCategory: $sizeFilterProductCategory
        sizeFilterCategory: $sizeFilterCategory
        sizeFilterFeature: $sizeFilterFeature
        sizeFilterClothingSize: $sizeFilterClothingSize
        sizeFilterShoeSize: $sizeFilterShoeSize
        sizeFilterStockQuantity: $sizeFilterStockQuantity
        sizeFilterColour: $sizeFilterColour
        isRatingCriteriaChecked: $isRatingCriteriaChecked
        selectedCriteria: $selectedCriteria
        notificationSubClusterIds: $notificationSubClusterIds
        ratingClusterIds: $ratingClusterIds
        ratingCriteriaByCluster: $ratingCriteriaByCluster
      }
    )
  }
`;

// $selectedCriteria: [String!], selectedCriteria: $selectedCriteria
export const UPDATE_PLATFORM_EVENT_CONTENT = gql`
  mutation updatePlatformEventContent(
    $contentId: String!
    $eventId: String!
    $name: String!
    $clusterId: String
    $notifClusterId: String
    $notifSubClusterId: String
    $contentPageSlug: String
    $contentPageType: String
    $body: String
    $imageURL: String
    $linkURL: String
    $keywords: [String!]
    $links: [ContentLinkInput!]
    $images: [String!]
    $subContentType: String!
    $isCartAvailable: Boolean
    $isScheduleAvailable: Boolean
    $isPricingAvailable: Boolean
    $isConstraintAvailable: Boolean
    $isVenueChecked: Boolean
    $selectedVenue: String
    $startDate: DateTime
    $endDate: DateTime
    $pricingType: PricingContentType
    $pricingMaster: CreatePricingInput
    $pricingEmployee: [CreatePricingEmployeeInput!]
    $userNotificationList: [String!]
    $sizeTypeId: String
    $sizeFilterGender: String
    $sizeFilterProductCategory: String
    $sizeFilterCategory: String
    $sizeFilterFeature: String
    $sizeFilterClothingSize: String
    $sizeFilterShoeSize: String
    $sizeFilterStockQuantity: String
    $sizeFilterColour: String
    $isRatingCriteriaChecked: Boolean
    $selectedCriteria: JSON
    $responseClusterId: String
    $responseSubClusterIds: [String!]
    $responseActions: JSON
    $notificationSubClusterIds: [String!]
    $ratingClusterIds: [String!]
    $ratingCriteriaByCluster: JSON
  ) {
    updatePlatformEventContent(
      data: {
        contentId: $contentId
        eventId: $eventId
        name: $name
        clusterId: $clusterId
        notifClusterId: $notifClusterId
        notifSubClusterId: $notifSubClusterId
        contentPageSlug: $contentPageSlug
        contentPageType: $contentPageType
        body: $body
        imageURL: $imageURL
        linkURL: $linkURL
        keywords: $keywords
        links: $links
        images: $images
        subContentType: $subContentType
        isCartAvailable: $isCartAvailable
        isScheduleAvailable: $isScheduleAvailable
        isPricingAvailable: $isPricingAvailable
        isConstraintAvailable: $isConstraintAvailable
        isVenueChecked: $isVenueChecked
        selectedVenue: $selectedVenue
        startDate: $startDate
        endDate: $endDate
        pricingType: $pricingType
        pricingMaster: $pricingMaster
        pricingEmployee: $pricingEmployee
        userNotificationList: $userNotificationList
        sizeTypeId: $sizeTypeId
        sizeFilterGender: $sizeFilterGender
        sizeFilterProductCategory: $sizeFilterProductCategory
        sizeFilterCategory: $sizeFilterCategory
        sizeFilterFeature: $sizeFilterFeature
        sizeFilterClothingSize: $sizeFilterClothingSize
        sizeFilterShoeSize: $sizeFilterShoeSize
        sizeFilterStockQuantity: $sizeFilterStockQuantity
        sizeFilterColour: $sizeFilterColour
        isRatingCriteriaChecked: $isRatingCriteriaChecked
        selectedCriteria: $selectedCriteria
        responseClusterId: $responseClusterId
        responseSubClusterIds: $responseSubClusterIds
        responseActions: $responseActions
        notificationSubClusterIds: $notificationSubClusterIds
        ratingClusterIds: $ratingClusterIds
        ratingCriteriaByCluster: $ratingCriteriaByCluster
      }
    )
  }
`;

export const TOGGLE_CONTENT_STATUS = gql`
  mutation toggleContentStatus($contentId: String!, $status: ContentStatus!) {
    toggleContentStatus(data: { contentId: $contentId, status: $status })
  }
`;

export const TOGGLE_CONTENT_PIN = gql`
  mutation toggleContentPin(
    $contentId: String!
    $pinnedAtAttendee: Boolean
    $pinnedAtAdmin: Boolean
  ) {
    toggleContentPin(
      data: {
        contentId: $contentId
        pinnedAtAttendee: $pinnedAtAttendee
        pinnedAtAdmin: $pinnedAtAdmin
      }
    )
  }
`;

export const CHECKOUT_EVENT_CART_ITEM = gql`
  mutation checkoutEventCartItemWithCard($data: CheckoutEventCartItemInput!) {
    checkoutEventCartItemWithCard(data: $data)
  }
`;

export const RESPOND_TO_CONTENT_SLOT = gql`
  mutation respondToContentSlot($data: RespondToContentSlotInput!) {
    respondToContentSlot(data: $data)
  }
`;

export const CONTENT_SLOT_RESPONSES = gql`
  query contentSlotResponses($data: ContentSlotResponsesInput!) {
    contentSlotResponses(data: $data)
  }
`;

export const CONTENT_SLOT_BOOKINGS = gql`
  query contentSlotBookings($data: ContentSlotResponsesInput!) {
    contentSlotBookings(data: $data)
  }
`;

export const PENDING_SLOT_DECLINE_REQUESTS = gql`
  query pendingSlotDeclineRequests($eventId: String!) {
    pendingSlotDeclineRequests(eventId: $eventId)
  }
`;

export const DECIDE_SLOT_DECLINE_REQUEST = gql`
  mutation decideSlotDeclineRequest($responseId: String!, $approve: Boolean!) {
    decideSlotDeclineRequest(responseId: $responseId, approve: $approve)
  }
`;

export const CANCEL_SLOT_BOOKING = gql`
  mutation cancelSlotBooking($slotId: String!) {
    cancelSlotBooking(slotId: $slotId)
  }
`;

export const CREATE_EVENT_BOOKING = gql`
  mutation createEvent(
    $eventID: String
    $contentID: String
    $name: String!
    $startAt: DateTime!
    $endAt: DateTime!
    $venueID: String!
    $invitees: [String!]
    $employeeIds: [String!]
    $eventType: EventType!
    $isFreeBookingSlot: Boolean
    $subClusterIds: [String!]
    $platformEventType: PlatformEventType!
  ) {
    createEvent(
      data: {
        name: $name
        eventID: $eventID
        contentID: $contentID
        startAt: $startAt
        endAt: $endAt
        venueID: $venueID
        invitees: $invitees
        employeeIds: $employeeIds
        eventType: $eventType
        isFreeBookingSlot: $isFreeBookingSlot
        subClusterIds: $subClusterIds
        platformEventType: $platformEventType
      }
    )
  }
`;

export const DELETE_EVENT_CART_ITEM = gql`
  mutation deleteEventCartItem($cartId: String!) {
    deleteEventCartItem(data: { cartId: $cartId })
  }
`;

export const UPSERT_CLUSTER_KPIS = gql`
  mutation upsertClusterKPIs($eventId: String!, $clusterId: String!, $kpis: [String!]!) {
    upsertClusterKPIs(data: { eventId: $eventId, clusterId: $clusterId, kpis: $kpis })
  }
`;

export const UPDATE_CART_ITEM_QUANTITY = gql`
  mutation updateCartItemQuantity($cartId: String!, $quantity: Float!) {
    updateCartItemQuantity(data: { cartId: $cartId, quantity: $quantity })
  }
`;

export const ADD_CONTENT_TO_CART = gql`
  mutation addContentToCart(
    $eventId: String!
    $itemId: String!
    $priceId: String!
    $type: String!
    $sizeId: String
    $selectedSize: String
    $venueId: String
    $selectedVenue: String
    $attendeeNames: [String!]
    $employeeNames: [String!]
    $attendeeIds: [String!]
    $employeeIds: [String!]
    $bookingDate: String
    $bookingTime: String
    $bookingTimeSlot: String
    $quantity: Float
  ) {
    addContentToCart(
      data: {
        eventId: $eventId
        itemId: $itemId
        priceId: $priceId
        type: $type
        sizeId: $sizeId
        selectedSize: $selectedSize
        bookingDate: $bookingDate
        bookingTime: $bookingTime
        bookingTimeSlot: $bookingTimeSlot
        venueId: $venueId
        selectedVenue: $selectedVenue
        attendeeIds: $attendeeIds
        employeeIds: $employeeIds
        attendeeNames: $attendeeNames
        employeeNames: $employeeNames
        quantity: $quantity
      }
    )
  }
`;

export const SUBMIT_RATING = gql`
  mutation submitRating(
    $eventId: String!
    $paymentId: String!
    $rating: Int!
    $comment: String
    $detailedRatings: String
    $isProduct: Boolean
  ) {
    submitRating(
      data: {
        eventId: $eventId
        paymentId: $paymentId
        rating: $rating
        comment: $comment
        detailedRatings: $detailedRatings
        isProduct: $isProduct
      }
    )
  }
`;

export const REQUEST_EVENT_ATTENDANCE = gql`
  mutation RequestEventAttendance($data: RequestEventAttendanceInput!) {
    requestEventAttendance(data: $data)
  }
`;

export const COMPLETE_LEAGUE_ONBOARDING = gql`
  mutation CompleteLeagueOnboarding($input: CompleteLeagueOnboardingInput!) {
    completeLeagueOnboarding(input: $input)
  }
`;

export const ACCEPT_LEAGUE_INVITATION = gql`
  mutation AcceptLeagueInvitation($token: String!) {
    acceptLeagueInvitation(token: $token)
  }
`;

export const ISSUE_LEAGUE_INVITE_TOKEN = gql`
  mutation IssueLeagueInviteToken($invitationId: String!) {
    issueLeagueInviteToken(invitationId: $invitationId)
  }
`;

export const ADD_COMPANY = gql`
  mutation addCompany($data: CreateCompanyInput!) {
    addCompany(data: $data)
  }
`;

export const CREATE_EVENT = gql`
  mutation createEvent(
    $name: String!
    $description: String
    $platformEventType: PlatformEventType!
    $eventType: EventType!
  ) {
    createEvent(
      data: {
        name: $name
        description: $description
        platformEventType: $platformEventType
        eventType: $eventType
      }
    )
  }
`;

export const SET_LEAGUE_TEAM_ALLOCATION = gql`
  mutation setLeagueTeamAllocation($data: SetLeagueTeamAllocationInput!) {
    setLeagueTeamAllocation(data: $data)
  }
`;

export const GENERATE_FIXTURES = gql`
  mutation generateFixtures($data: GenerateFixturesInput!) {
    generateFixtures(data: $data)
  }
`;

export const UPDATE_LEAGUE_FIXTURE = gql`
  mutation updateLeagueFixture($data: UpdateLeagueFixtureInput!) {
    updateLeagueFixture(data: $data)
  }
`;

export const PUBLISH_LEAGUE_FIXTURES = gql`
  mutation publishLeagueFixtures($data: PublishLeagueFixturesInput!) {
    publishLeagueFixtures(data: $data)
  }
`;
